import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=5cbb7680&scoped=true"
import script from "./rejectDialog.vue?vue&type=script&lang=js"
export * from "./rejectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb7680",
  null
  
)

export default component.exports